// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc6eb51d","239":"dfe6393c","453":"1df44d83","455":"4f6aacda","557":"16763950","762":"8c69ca06"}[chunkId] + ".chunk.js";
};